module.exports = __webpack_public_path__ + "static/media/woman-paying-with-credit-card.c693d069.jpg";